import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ButtonIcon } from "Components/Shared";
import { GeminiPromptObjectType } from "Interfaces/Pages/GeminiPromptsInterface";
import { PermissionsObjType } from "Interfaces/UtilsInterface";
import { isAllowedTo } from "Utils/helper";
import { ReactNode } from "react";

export const GEMINI_PROMPTS = "SportsSkill AI Prompts";
export const CREATE_NEW_PROMPT = "Create New Prompt";

interface GeminiPromptColumnType {
  dataField?: string;
  title: string;
  colWidth?: string;
  formatter?: (props: GeminiPromptObjectType) => ReactNode | string;
}

interface GetColumnsParams {
  onUpdate?: (id: number) => void;
  permissions: PermissionsObjType;
}

export const getColumns = ({
  onUpdate,
  permissions,
}: GetColumnsParams): GeminiPromptColumnType[] => {
  const columns: GeminiPromptColumnType[] = [
    {
      dataField: "master_sport",
      title: "Name",
      formatter: (props: GeminiPromptObjectType) => {
        if (props.is_default) {
          const category =
            props.prompt_category === "exercise" ? "exercise" : "sport";
          return `DEFAULT - ${category}`;
        }
        if (props.prompt_category === "exercise") {
          return props.exercise_type ?? "----";
        }
        return props.master_sport?.name ?? "----";
      },
    },
    {
      dataField: "prompt",
      title: "Prompt",
      formatter: (props: GeminiPromptObjectType) => {
        // Preserve formatting (newlines, tabs) by using white-space: pre-wrap
        return <div style={{ whiteSpace: "pre-wrap" }}>{props.prompt}</div>;
      },
    },
  ];

  // Add actions column if user has update permission
  if (isAllowedTo("GeminiPrompt", "update", permissions)) {
    columns.push({
      dataField: "actions",
      title: "Actions",
      colWidth: "6.25rem",
      formatter: (props: GeminiPromptObjectType) => (
        <div className="d-flex" key={props.id}>
          <ButtonIcon
            onClick={(event) => {
              event.stopPropagation();
              onUpdate && onUpdate(props.id);
            }}
          >
            <FontAwesomeIcon icon={faPencil} />
          </ButtonIcon>
        </div>
      ),
    });
  }

  return columns.filter(Boolean);
};
